var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3 text-center text-info",attrs:{"id":"loading"}},[_c('fa-icon',{staticClass:"loading fa-spin",attrs:{"icon":['fal', 'atom-alt']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }